import * as React from 'react'
import { InvoicesController } from '../../controllers'
import Notification from '../../utilities/Notification'
import moment from '../../utilities/Moment'
import CardEmptyInfo from '../Card/CardEmptyInfo'
import { withRouter, RouteComponentProps } from 'react-router'
import RouteHelper from '../../helpers/RouteHelper'
import LedgerItemHelper from '../../helpers/LedgerItemHelper'
import ERoute from '../../ERoute';
import { IActionListItem } from '../ActionList/ActionList'
import LedgerItemAvatar from '../Avatar/LedgerItemAvatar'
import PageLoader from '../Page/PageLoader'
import { AnyAction, Dispatch } from 'redux'
import { showConfirmModal, showSendLedgerItemModal } from '../../store/modals/actions'
import { connect } from 'react-redux'
import LocalStorage, { LocalStorageKey } from '../../LocalStorage'
import { Helmet } from 'react-helmet'
import { WithTranslation, withTranslation } from 'react-i18next'
import ButtonPanel from '../Button/ButtonPanel'
import OrderFormAvatar from '../Avatar/OrderFormAvatar'
import DeliveryNoteAvatar from '../Avatar/DeliveryNoteAvatar'
import ResourceTable from '../Resource/ResourceTable'
import ResourceTableRow from '../Resource/ResourceTableRow'
import ResourceTableRowData from '../Resource/ResourceTableRowData'
import NumberFormatter from '../../utilities/NumberFormatter'
import ResourceTableRowActions from '../Resource/ResourceTableRowActions'
import { CurrentUser, LedgerItem, LedgerItemFilter, LedgerItemFilters, LedgerItemStatus, LedgerItemType, ResourceListFilterType } from '../../types'
import { AppState } from '../../store'
import SearchHelper from '../../helpers/SearchHelper'
import NavigationDetection from '../Effects/NavigationDetection'
import getInvoiceTableRenderer from '../Resource/InvoiceRenderer'
import getQuotationTableRenderer from '../Resource/QuotationRenderer'
import getCreditNoteTableRenderer from '../Resource/CreditNoteRenderer'
import getRecurringInvoiceTableRenderer from '../Resource/RecurringInvoiceRenderer'

export interface IComponentProps {
  type: LedgerItemType
  contactId?: string
  projectId?: string
  dealId?: string
  primaryActionEnabled?: boolean
  onItemUpdated?: () => void,
  onItemDeleted?: () => void,
  urlRewriteEnabled?: boolean
}

interface IStateToProps {
  currentUser: CurrentUser
}
interface IDispatchToProps {
  showSendLedgerItemModal: typeof showSendLedgerItemModal
  showConfirmModal: typeof showConfirmModal
}

type IProps = IComponentProps & IStateToProps & IDispatchToProps & RouteComponentProps<any> & WithTranslation

interface IState {
  ledgerItems: LedgerItem[]
  page: number
  perPage: number
  totalPages: number
  didInitialLoad: boolean
  sortValue: string
  isFetching: boolean
  activeFilters: any
  search: string
}

class LedgerItemsTable extends React.Component<IProps, IState> {
  constructor(props) {
    super(props)

    const { search, page, perPage, filters, } = SearchHelper.getSearch(this.props.location.search, LedgerItemFilters)

    this.state = {
      ledgerItems: [],
      page: page,
      perPage: perPage,
      totalPages: 1,
      didInitialLoad: false,
      sortValue: props.type !== LedgerItemType.RECURRING_INVOICE ? LocalStorage.get(LocalStorageKey.LEDGER_ITEM_SORT_VALUE, 'number_desc') : LocalStorage.get(LocalStorageKey.RECURRING_INVOICE_SORT_VALUE, 'recurring_schedules.next_occurrence_on_asc'),
      isFetching: false,
      search: search,
      activeFilters: filters,
    }

    this.onRouteChange = this.onRouteChange.bind(this)
    this.onNewLedgerItemClick = this.onNewLedgerItemClick.bind(this)
    this.onTableLedgerItemSend = this.onTableLedgerItemSend.bind(this)
    this.onTableLedgerItemClick = this.onTableLedgerItemClick.bind(this);
    this.onTableLedgerItemApprovedClick = this.onTableLedgerItemApprovedClick.bind(this);
    this.onTableLedgerItemRejectClick = this.onTableLedgerItemRejectClick.bind(this);
    this.onTableLedgerItemPaidClick = this.onTableLedgerItemPaidClick.bind(this);
    this.onTableLedgerItemEditClick = this.onTableLedgerItemEditClick.bind(this);
    this.onTableLedgerItemDownloadClick = this.onTableLedgerItemDownloadClick.bind(this);
    this.onTableLedgerItemDeleteClick = this.onTableLedgerItemDeleteClick.bind(this);
    this.onTableLedgerItemActionClick = this.onTableLedgerItemActionClick.bind(this)
    this.onTableLedgerItemRecurringAutoSendToggle = this.onTableLedgerItemRecurringAutoSendToggle.bind(this)
    this.onLedgerItemFiltersChange = this.onLedgerItemFiltersChange.bind(this)
    this.onLedgerItemSortValueChange = this.onLedgerItemSortValueChange.bind(this)
    this.onLedgerItemSearchChange = this.onLedgerItemSearchChange.bind(this)
    this.onLedgerItemSearchSubmit = this.onLedgerItemSearchSubmit.bind(this)
    this.onLedgerItemClearFilters = this.onLedgerItemClearFilters.bind(this)
    this.onPageChange = this.onPageChange.bind(this)
    this.onPerPageChange = this.onPerPageChange.bind(this)
    this.onQuotationColumnsChange = this.onQuotationColumnsChange.bind(this)
    this.onInvoiceColumnsChange = this.onInvoiceColumnsChange.bind(this)
    this.onCreditNoteColumnsChange = this.onCreditNoteColumnsChange.bind(this)
    this.onRecurringInvoiceColumnsChange = this.onRecurringInvoiceColumnsChange.bind(this)
  }

  getTitle() {
    const { type, t } = this.props

    switch (type) {
      case LedgerItemType.ORDER_FORM:
        return t('LedgerItemsTable::{{__appName}} | Order forms')
      case LedgerItemType.DELIVERY_NOTE:
        return t('LedgerItemsTable::{{__appName}} | Delivery notes')
      case LedgerItemType.QUOTATION:
        return t('LedgerItemsTable::{{__appName}} | Quotations')
      case LedgerItemType.INVOICE:
        return t('LedgerItemsTable::{{__appName}} | Invoices')
      case LedgerItemType.CREDIT_NOTE:
        return t('LedgerItemsTable::{{__appName}} | Credit notes')
      case LedgerItemType.RECURRING_INVOICE:
        return t('LedgerItemsTable::{{__appName}} | Recurring invoices')
    }
  }
  onRouteChange() {
    const { search, page, filters } = SearchHelper.getSearch(this.props.location.search, LedgerItemFilters)

    this.setState({ search: search, page: page, activeFilters: filters }, () => {
      this.fetchLedgerItems(page)
    })
  }

  rehydratedFetch() {
    const { urlRewriteEnabled } = this.props
    const { page, perPage, activeFilters, search, sortValue } = this.state

    if (urlRewriteEnabled) {
      RouteHelper.replace(this.props.location.pathname as ERoute, {
        page: page,
        perPage: perPage,
        search: search,
        ...activeFilters,
        sortValue: sortValue
      })
    } else {
      this.fetchLedgerItems(page)
    }
  }

  fetchLedgerItems(page = 1) {
    const { search, sortValue, activeFilters, perPage } = this.state
    const { type, contactId, projectId, dealId } = this.props
    let parameters: any = {
      type: type,
      search: search,
      order: sortValue,
      per_page: perPage,
      ...activeFilters,
    };

    if (contactId) {
      parameters = {
        ...parameters,
        contact_id: contactId,
      }
    }

    if (projectId) {
      parameters = {
        ...parameters,
        project_id: projectId,
      }
    }

    if (dealId) {
      parameters = {
        ...parameters,
        deal_id: dealId,
      }
    }

    this.setState({ isFetching: true })
    InvoicesController
      .getInvoices(page, parameters)
      .then(response => {
        const { current_page, total_pages, invoices: newLedgerItems } = response
        const { ledgerItems } = this.state;

        this.setState({
          ledgerItems: newLedgerItems,
          page: current_page,
          totalPages: total_pages,
          didInitialLoad: true,
          isFetching: false,
        });
      })
      .catch(console.error)
      .finally(() => {
        this.setState({ isFetching: false })
      })
  }

  updateLedgerItem(ledgerItem: LedgerItem, callback) {
    const { t } = this.props
    InvoicesController
      .update(ledgerItem)
      .then(response => {
        const { errors } = response;

        if (errors) {
          Notification.notifyError(t('LedgerItemsTable::Oops something went wrong!'))
        }
        else {
          Notification.notifySuccess(t('LedgerItemsTable::Updated successfully'))
          callback(response);
        }
      });
  }

  deleteLedgerItem(ledgerItem, callback) {
    const { t } = this.props

    InvoicesController
      .delete(ledgerItem.id)
      .then(response => {
        Notification.notifySuccess(t('LedgerItemsTable::Deleted successfully'))
        callback(response);
      })
  }

  getLedgerItemColor(ledgerItem) {
    if (ledgerItem.project) {
      return ledgerItem.project.color;
    }
    else if (ledgerItem.contact) {
      return ledgerItem.contact.color;
    }

    return '#ccc';
  }

  onNewLedgerItemClick() {
    const { history, contactId, projectId, dealId, type } = this.props

    let params = {
      type: type,
    }

    if (contactId) params['contact_id'] = contactId
    if (projectId) params['project_id'] = projectId
    if (dealId) params['deal_id'] = dealId

    history.push(RouteHelper.process(ERoute.PATH_INVOICES_NEW, params))
  }

  onTableLedgerItemClick(ledgerItem) {
    this.props.history.push(RouteHelper.process(ERoute.PATH_INVOICE, { id: ledgerItem.id }))
  }

  onTableLedgerItemRecurringAutoSendToggle(e, ledgerItem: LedgerItem) {
    e.preventDefault()
    e.stopPropagation()
    const { ledgerItems } = this.state

    try {
      const enabled = !ledgerItem.recurring_auto_send
      this.setState({ ledgerItems: ledgerItems.map(c => c.id === ledgerItem.id ? { ...c, recurring_auto_send: enabled } : c) })
      this.updateLedgerItem({ ...ledgerItem, recurring_auto_send: enabled }, () => { })
    } catch (ex) {
      console.error(ex)
    }
  }

  async onTableLedgerItemSend(ledgerItem: LedgerItem) {
    this.props.showSendLedgerItemModal({
      ledgerItemId: ledgerItem.id,
      onSubmit: (ledgerItem) => {
        const { ledgerItems } = this.state

        const index = ledgerItems.findIndex(l => l.id === ledgerItem.id)

        if (index !== -1) {
          ledgerItems[index] = ledgerItem

          this.setState({ ledgerItems: [...ledgerItems] })
        }
      }
    })
  }

  onTableLedgerItemSendPeppol(ledgerItem: LedgerItem) {
    const { t } = this.props
    const { ledgerItems } = this.state

    this.props.showConfirmModal({
      title: t('InvoiceShow::Send via Peppol'),
      description: t('InvoiceShow::You are about to send this {{ledgerItemType}} to <b>{{contact}}</b> via the Peppol network. Are you sure?', {
        ledgerItemType: LedgerItemHelper.getTypeLabel(ledgerItem.type).toLowerCase(),
        contact: ledgerItem?.contact?.name
      }),
      action: {
        label: t('InvoiceShow::Confirm'),
      },
      onConfirm: async () => {
        try {
          const updatedLedgerItem = await InvoicesController.sendPeppol(ledgerItem.id)

          if (updatedLedgerItem?.peppol_id) {
            Notification.notifySuccess(t('InvoiceShow::{{ledgerItemType}} succesfully send.', { ledgerItemType: LedgerItemHelper.getTypeLabel(ledgerItem.type) }))
          } else {
            Notification.notifyError(t('InvoiceShow::Failed to send via Peppol. Contact support for more information'))
          }
          const index = ledgerItems.findIndex(l => l.id === ledgerItem.id)

          if (index !== -1) {
            ledgerItems[index] = updatedLedgerItem

            this.setState({ ledgerItems: [...ledgerItems] })
          }
        } catch (ex) {
          console.error(ex)
        }
      }
    })
  }

  async onTableLedgerItemDuplicate(ledgerItem: LedgerItem) {
    try {
      const response = await InvoicesController.duplicate(ledgerItem.id)

      if (response && !response.errors) {
        this.props.history.push(RouteHelper.process(ERoute.PATH_INVOICE_EDIT, { id: response.id }))
      }
    } catch (ex) {
      console.error(ex)
    }
  }

  async onTableCreateCreditNoteClick(ledgerItem: LedgerItem) {
    const { t, showConfirmModal } = this.props

    try {
      showConfirmModal({
        title: t('LedgerItemsTable::Generate credit note'),
        description: t('LedgerItemsTable::You are about to generate a credit note for invoice <b>{{number}}</b>. Are you sure?', { number: ledgerItem.number }),
        action: { label: t('LedgerItemsTable::Generate') },
        onConfirm: async () => {
          const response = await InvoicesController.createCreditNote(ledgerItem.id)

          if (response && !response.errors) {
            this.props.history.push(RouteHelper.process(ERoute.PATH_INVOICE_EDIT, { id: response.id }))
          }
        }
      })
    } catch (ex) {
      console.error(ex)
    }
  }

  onTableLedgerItemApprovedClick(ledgerItem) {
    const { onItemUpdated } = this.props

    const updatedLedgerItem = Object.assign({}, ledgerItem, {
      issued_on: ledgerItem.issued_on ? moment(ledgerItem.issued_on).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
      due_on: ledgerItem.due_on ? moment(ledgerItem.due_on).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
      approved_on: moment().format('YYYY-MM-DD')
    });

    this.updateLedgerItem(updatedLedgerItem, (updatedLedgerItem) => {
      const { ledgerItems } = this.state

      const ledgerItemIndex = ledgerItems.findIndex(i => i.id === ledgerItem.id);
      ledgerItems[ledgerItemIndex] = updatedLedgerItem

      this.setState({
        ledgerItems
      }, () => {
        if (onItemUpdated) onItemUpdated()
      });
    });
  }

  onTableLedgerItemRejectClick(ledgerItem) {
    const { onItemUpdated } = this.props

    const updatedLedgerItem: LedgerItem = {
      ...ledgerItem,
      issued_on: ledgerItem.issued_on ? moment(ledgerItem.issued_on).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
      due_on: ledgerItem.due_on ? moment(ledgerItem.due_on).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
      rejected_on: moment().format('YYYY-MM-DD')
    };

    this.updateLedgerItem(updatedLedgerItem, (updatedLedgerItem) => {
      const { ledgerItems } = this.state

      const ledgerItemIndex = ledgerItems.findIndex(i => i.id === ledgerItem.id);
      ledgerItems[ledgerItemIndex] = updatedLedgerItem

      this.setState({
        ledgerItems
      }, () => {
        if (onItemUpdated) onItemUpdated()
      });
    });
  }

  onTableLedgerItemPaidClick(ledgerItem) {
    const { onItemUpdated } = this.props

    const updatedLedgerItem = Object.assign({}, ledgerItem, {
      issued_on: ledgerItem.issued_on ? moment(ledgerItem.issued_on).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
      due_on: ledgerItem.due_on ? moment(ledgerItem.due_on).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
      paid_on: moment().format('YYYY-MM-DD')
    });

    this.updateLedgerItem(updatedLedgerItem, (updatedLedgerItem) => {
      const { ledgerItems } = this.state

      const ledgerItemIndex = ledgerItems.findIndex(i => i.id === ledgerItem.id);
      ledgerItems[ledgerItemIndex] = updatedLedgerItem

      this.setState({
        ledgerItems
      }, () => {
        if (onItemUpdated) onItemUpdated()
      });
    });
  }

  onTableLedgerItemEditClick(ledgerItem) {
    const { history } = this.props
    history.push(RouteHelper.process(ERoute.PATH_INVOICE_EDIT, { id: ledgerItem.id }))
  }

  onTableLedgerItemDownloadClick(ledgerItem, type: 'pdf' | 'ubl' = 'pdf') {
    LedgerItemHelper.download(ledgerItem, type)
  }

  onTableLedgerItemDeleteClick(ledgerItem: LedgerItem) {
    const { onItemDeleted, showConfirmModal, t } = this.props

    const typeLabel = LedgerItemHelper.getTypeLabel(ledgerItem.type)

    showConfirmModal({
      title: t('LedgerItemsTable::Delete {{type}}', { type: typeLabel }),
      description: t('LedgerItemsTable::You are about to delete a {{type}}. Deletion is permanent and irreversible. Are you sure?', { type: typeLabel.toLowerCase() }),
      action: { label: t('LedgerItemsTable::Delete'), isDestructive: true },
      onConfirm: () => {
        this.deleteLedgerItem(ledgerItem, () => {
          const { ledgerItems } = this.state

          const ledgerItemIndex = ledgerItems.findIndex(i => i.id === ledgerItem.id);
          ledgerItems.splice(ledgerItemIndex, 1);

          this.setState({
            ledgerItems
          });

          if (onItemDeleted) onItemDeleted()
        })
      }
    })
  }

  onTableLedgerItemActionClick(key: string, ledgerItem: LedgerItem) {
    switch (key) {
      case 'send': this.onTableLedgerItemSend(ledgerItem)
        break
      case 'send_peppol': this.onTableLedgerItemSendPeppol(ledgerItem)
        break
      case 'duplicate': this.onTableLedgerItemDuplicate(ledgerItem)
        break
      case 'create_credit_note': this.onTableCreateCreditNoteClick(ledgerItem)
        break
      case 'approve': this.onTableLedgerItemApprovedClick(ledgerItem)
        break
      case 'reject': this.onTableLedgerItemRejectClick(ledgerItem)
        break
      case 'view': this.onTableLedgerItemClick(ledgerItem)
        break
      case 'edit': this.onTableLedgerItemEditClick(ledgerItem)
        break
      case 'download': this.onTableLedgerItemDownloadClick(ledgerItem)
        break
      case 'download_ubl': this.onTableLedgerItemDownloadClick(ledgerItem, 'ubl')
        break
      case 'delete': this.onTableLedgerItemDeleteClick(ledgerItem)
        break
      case 'mark_paid': this.onTableLedgerItemPaidClick(ledgerItem)
        break
      default:
        throw Error('[LedgerItemsTable] Unimplemented onTableLedgerItemActionClick')
    }
  }

  onLedgerItemFiltersChange(activeFilters: any) {
    this.setState({ page: 1, activeFilters: activeFilters }, () => {
      this.rehydratedFetch()
    })
  }

  onLedgerItemSortValueChange(value: string) {
    const { type } = this.props

    if (type === LedgerItemType.RECURRING_INVOICE) {
      LocalStorage.set(LocalStorageKey.RECURRING_INVOICE_SORT_VALUE, value)
    } else {
      LocalStorage.set(LocalStorageKey.LEDGER_ITEM_SORT_VALUE, value)
    }

    this.setState({ page: 1, sortValue: value, }, () => {
      this.rehydratedFetch()
    })
  }

  onLedgerItemSearchChange(search) {
    this.setState({ search: search })
  }

  onLedgerItemSearchSubmit(search) {
    this.setState({ page: 1, search: search }, () => {
      this.rehydratedFetch()
    })
  }

  onLedgerItemClearFilters() {
    this.setState({
      page: 1,
      search: '',
      activeFilters: {}
    }, this.rehydratedFetch)
  }

  onPageChange(page) {
    this.setState({ page: page }, () => {
      this.rehydratedFetch()
    })
  }

  onPerPageChange(perPage) {
    this.setState({ page: 1, perPage: perPage }, () => {
      LocalStorage.set(LocalStorageKey.PER_PAGE, perPage)
      this.rehydratedFetch()
    })
  }

  onQuotationColumnsChange(columns: string[]) {
    LocalStorage.set(LocalStorageKey.QUOTATION_COLUMNS, columns)
    this.forceUpdate()
  }

  onInvoiceColumnsChange(columns: string[]) {
    LocalStorage.set(LocalStorageKey.INVOICE_COLUMNS, columns)
    this.forceUpdate()
  }

  onCreditNoteColumnsChange(columns: string[]) {
    LocalStorage.set(LocalStorageKey.CREDIT_NOTE_COLUMNS, columns)
    this.forceUpdate()
  }

  onRecurringInvoiceColumnsChange(columns: string[]) {
    LocalStorage.set(LocalStorageKey.RECURRING_INVOICE_COLUMNS, columns)
    this.forceUpdate()
  }

  renderOrderForms() {
    const { t } = this.props
    const { currentUser: { workspace: { setting } }, contactId, projectId, primaryActionEnabled } = this.props
    const { didInitialLoad, ledgerItems, page, totalPages, sortValue, isFetching, activeFilters, search, perPage } = this.state;

    const filtersActive = search?.length > 0 || Object.keys(activeFilters).length > 0
    const filters: LedgerItemFilter[] = [
      { name: 'contact_id', label: t('LedgerItemsTable::Client'), type: ResourceListFilterType.SINGLE_RESOURCE, resourceType: 'contact', isValidNewOption: () => false, visible: !Boolean(contactId) },
      { name: 'project_id', label: t('LedgerItemsTable::Project'), type: ResourceListFilterType.SINGLE_RESOURCE, resourceType: 'project', isValidNewOption: () => false, visible: !Boolean(projectId) },
      { name: 'number', label: t('LedgerItemsTable::Number'), type: ResourceListFilterType.STRING },
      { name: 'identifier', label: t('LedgerItemsTable::Identifier'), type: ResourceListFilterType.STRING },
      { name: 'net_total', label: t('LedgerItemsTable::Net amount'), type: ResourceListFilterType.NUMBER },
      { name: 'amount', label: t('LedgerItemsTable::Amount'), type: ResourceListFilterType.NUMBER },
      { name: 'issued_on', label: t('LedgerItemsTable::Issued on'), type: ResourceListFilterType.DATE },
      { name: 'delivered_on', label: t('LedgerItemsTable::Delivered on'), type: ResourceListFilterType.DATE },
      { name: 'created_at', label: t('LedgerItemsTable::Created date'), type: ResourceListFilterType.DATE },
    ]

    return (
      <>
        <Helmet>
          <title>{this.getTitle()}</title>
        </Helmet>
        {!didInitialLoad && <PageLoader />}
        {didInitialLoad && <ResourceTable
          data={ledgerItems}
          headers={[
            { title: '' },
            { title: t('LedgerItemsTable::Number') },
            { title: t('LedgerItemsTable::Client') },
            { title: t('LedgerItemsTable::Issued on'), align: 'right' },
            { title: t('LedgerItemsTable::Delivered on'), align: 'right' },
            { title: t('LedgerItemsTable::Net amount'), align: 'right' },
            { title: t('LedgerItemsTable::Amount'), align: 'right' },
            { title: '', stickyRight: '0px' },
          ]}
          actionsLeft={primaryActionEnabled ? [
            <ButtonPanel
              icon='plus'
              text={t('LedgerItemsTable::New order form')}
              onClick={this.onNewLedgerItemClick}
            />
          ] : null}
          renderRow={(ledgerItem: LedgerItem) => {
            let actions: IActionListItem[] = [
              { key: 'send', icon: 'send', content: t('LedgerItemsTable::Send') },
              { key: 'view', icon: 'eye', content: t('LedgerItemsTable::View') },
              { key: 'duplicate', icon: 'duplicate', content: t('LedgerItemsTable::Duplicate') },
              { key: 'edit', icon: 'edit', content: t('LedgerItemsTable::Edit') },
              { key: 'download', icon: 'pdf', content: t('LedgerItemsTable::Download PDF'), visible: Boolean(ledgerItem.pdf_attachment_download_url) },
              { key: 'delete', icon: 'trash-alt-solid', content: t('LedgerItemsTable::Delete'), destructive: true },
            ]

            return (
              <ResourceTableRow key={ledgerItem.id}>
                <ResourceTableRowData onClick={(): void => this.onTableLedgerItemClick(ledgerItem)} maxWidth='30px' maxWidthMobile='50px'>
                  <OrderFormAvatar ledgerItem={ledgerItem} width={30} rounded={true} onClick={() => this.onTableLedgerItemClick(ledgerItem)} />
                </ResourceTableRowData>
                <ResourceTableRowData onClick={(): void => this.onTableLedgerItemClick(ledgerItem)} maxWidth='150px' ellipse>
                  {ledgerItem.number}
                </ResourceTableRowData>
                <ResourceTableRowData onClick={(): void => this.onTableLedgerItemClick(ledgerItem)} maxWidth='150px' ellipse>
                  {ledgerItem?.contact?.name || '-'}
                </ResourceTableRowData>
                <ResourceTableRowData onClick={(): void => this.onTableLedgerItemClick(ledgerItem)} textAlign='right'>
                  {ledgerItem?.issued_on ? moment(ledgerItem.issued_on).format(setting.date_format) : '-'}
                </ResourceTableRowData>
                <ResourceTableRowData onClick={(): void => this.onTableLedgerItemClick(ledgerItem)} textAlign='right'>
                  {ledgerItem?.delivered_on ? moment(ledgerItem.delivered_on).format(setting.date_format) : '-'}
                </ResourceTableRowData>
                <ResourceTableRowData onClick={(): void => this.onTableLedgerItemClick(ledgerItem)} textAlign='right'>
                  {NumberFormatter.formatCurrency(ledgerItem.currency || setting.default_currency, setting.number_format, ledgerItem.net_total)}
                </ResourceTableRowData>
                <ResourceTableRowData onClick={(): void => this.onTableLedgerItemClick(ledgerItem)} textAlign='right'>
                  {NumberFormatter.formatCurrency(ledgerItem.currency || setting.default_currency, setting.number_format, ledgerItem.amount)}
                </ResourceTableRowData>
                <ResourceTableRowActions
                  actions={actions}
                  onActionClick={(key) => this.onTableLedgerItemActionClick(key, ledgerItem)}
                  sticky={true}
                  stickyRight='0px'
                />
              </ResourceTableRow>
            )
          }}
          renderEmpty={<CardEmptyInfo
            icon={filtersActive ? 'search' : 'invoice'}
            description={filtersActive ? t('LedgerItemsTable::No order forms found') : t('LedgerItemsTable::No order forms have been created yet')}
            descriptionActionText={filtersActive ? t('LedgerItemsTable::Clear filters') : t('LedgerItemsTable::Add order form')}
            onDescriptionActionClick={filtersActive ? this.onLedgerItemClearFilters : this.onNewLedgerItemClick}
          />}
          filters={filters}
          activeFilters={activeFilters}
          onFiltersChange={this.onLedgerItemFiltersChange}
          sortOptions={[
            { label: t('LedgerItemsTable::Number ↑'), value: 'number_asc' },
            { label: t('LedgerItemsTable::Number ↓'), value: 'number_desc' },
            { label: t('LedgerItemsTable::Issued on ↑'), value: 'issued_on_asc' },
            { label: t('LedgerItemsTable::Issued on ↓'), value: 'issued_on_desc' },
            { label: t('LedgerItemsTable::Due on ↑'), value: 'due_on_asc' },
            { label: t('LedgerItemsTable::Due on ↓'), value: 'due_on_desc' },
            { label: t('LedgerItemsTable::Delivered on ↑'), value: 'delivered_on_asc' },
            { label: t('LedgerItemsTable::Delivered on ↓'), value: 'delivered_on_desc' },
            { label: t('LedgerItemsTable::Invoiced on ↑'), value: 'invoiced_on_asc' },
            { label: t('LedgerItemsTable::Invoiced on ↓'), value: 'invoiced_on_desc' },
            { label: t('LedgerItemsTable::Net amount ↑'), value: 'net_total_asc' },
            { label: t('LedgerItemsTable::Net amount ↓'), value: 'net_total_desc' },
            { label: t('LedgerItemsTable::Amount ↑'), value: 'amount_asc' },
            { label: t('LedgerItemsTable::Amount ↓'), value: 'amount_desc' },
            { label: t('LedgerItemsTable::Created at ↑'), value: 'created_at_asc' },
            { label: t('LedgerItemsTable::Created at ↓'), value: 'created_at_desc' },
          ]}
          sortValue={sortValue}
          onSortChange={this.onLedgerItemSortValueChange}
          pagination={{ page: page, perPage: perPage, pageCount: totalPages }}
          onPageChange={this.onPageChange}
          onPerPageChange={this.onPerPageChange}
          searchValue={search}
          onSearchChange={this.onLedgerItemSearchChange}
          onSearchSubmit={this.onLedgerItemSearchSubmit}
          isLoading={isFetching}
          maxHeight='65vh'
          stickyHeader={true}
        />}
      </>
    );
  }

  renderDeliveryNotes() {
    const { t } = this.props
    const { currentUser: { workspace: { setting } }, contactId, projectId, primaryActionEnabled } = this.props
    const { didInitialLoad, ledgerItems, page, totalPages, sortValue, isFetching, activeFilters, search, perPage } = this.state;

    const filtersActive = search?.length > 0 || Object.keys(activeFilters).length > 0
    const filters: LedgerItemFilter[] = [
      { name: 'contact_id', label: t('LedgerItemsTable::Client'), type: ResourceListFilterType.SINGLE_RESOURCE, resourceType: 'contact', isValidNewOption: () => false, visible: !Boolean(contactId) },
      { name: 'project_id', label: t('LedgerItemsTable::Project'), type: ResourceListFilterType.SINGLE_RESOURCE, resourceType: 'project', isValidNewOption: () => false, visible: !Boolean(projectId) },
      { name: 'number', label: t('LedgerItemsTable::Number'), type: ResourceListFilterType.STRING },
      { name: 'identifier', label: t('LedgerItemsTable::Identifier'), type: ResourceListFilterType.STRING },
      { name: 'net_total', label: t('LedgerItemsTable::Net amount'), type: ResourceListFilterType.NUMBER },
      { name: 'amount', label: t('LedgerItemsTable::Amount'), type: ResourceListFilterType.NUMBER },
      { name: 'issued_on', label: t('LedgerItemsTable::Delivered on'), type: ResourceListFilterType.DATE },
      { name: 'invoiced_on', label: t('LedgerItemsTable::Invoiced on'), type: ResourceListFilterType.DATE },
      { name: 'created_at', label: t('LedgerItemsTable::Created date'), type: ResourceListFilterType.DATE },
    ]

    return (
      <>
        <Helmet>
          <title>{this.getTitle()}</title>
        </Helmet>
        {!didInitialLoad && <PageLoader />}
        {didInitialLoad && <ResourceTable
          data={ledgerItems}
          headers={[
            { title: '' },
            { title: t('LedgerItemsTable::Number') },
            { title: t('LedgerItemsTable::Client') },
            { title: t('LedgerItemsTable::Delivered on'), align: 'right' },
            { title: t('LedgerItemsTable::Invoiced on'), align: 'right' },
            { title: t('LedgerItemsTable::Net amount'), align: 'right' },
            { title: t('LedgerItemsTable::Amount'), align: 'right' },
            { title: '', stickyRight: '0px' },
          ]}
          actionsLeft={primaryActionEnabled ? [
            <ButtonPanel
              icon='plus'
              text={t('LedgerItemsTable::New delivery note')}
              onClick={this.onNewLedgerItemClick}
            />
          ] : null}
          renderRow={(ledgerItem: LedgerItem) => {
            let actions: IActionListItem[] = [
              { key: 'send', icon: 'send', content: t('LedgerItemsTable::Send') },
              { key: 'view', icon: 'eye', content: t('LedgerItemsTable::View') },
              { key: 'duplicate', icon: 'duplicate', content: t('LedgerItemsTable::Duplicate') },
              { key: 'edit', icon: 'edit', content: t('LedgerItemsTable::Edit') },
              { key: 'download', icon: 'pdf', content: t('LedgerItemsTable::Download PDF'), visible: Boolean(ledgerItem.pdf_attachment_download_url) },
              { key: 'delete', icon: 'trash-alt-solid', content: t('LedgerItemsTable::Delete'), destructive: true },
            ]

            return (
              <ResourceTableRow key={ledgerItem.id}>
                <ResourceTableRowData onClick={(): void => this.onTableLedgerItemClick(ledgerItem)} maxWidth='30px' maxWidthMobile='50px'>
                  <DeliveryNoteAvatar ledgerItem={ledgerItem} width={30} rounded={true} onClick={() => this.onTableLedgerItemClick(ledgerItem)} />
                </ResourceTableRowData>
                <ResourceTableRowData onClick={(): void => this.onTableLedgerItemClick(ledgerItem)} maxWidth='150px' ellipse>
                  {ledgerItem.number}
                </ResourceTableRowData>
                <ResourceTableRowData onClick={(): void => this.onTableLedgerItemClick(ledgerItem)} maxWidth='150px' ellipse>
                  {ledgerItem?.contact?.name || '-'}
                </ResourceTableRowData>
                <ResourceTableRowData onClick={(): void => this.onTableLedgerItemClick(ledgerItem)} textAlign='right'>
                  {ledgerItem?.issued_on ? moment(ledgerItem.issued_on).format(setting.date_format) : '-'}
                </ResourceTableRowData>
                <ResourceTableRowData onClick={(): void => this.onTableLedgerItemClick(ledgerItem)} textAlign='right'>
                  {ledgerItem?.invoiced_on ? moment(ledgerItem.invoiced_on).format(setting.date_format) : '-'}
                </ResourceTableRowData>
                <ResourceTableRowData onClick={(): void => this.onTableLedgerItemClick(ledgerItem)} textAlign='right'>
                  {NumberFormatter.formatCurrency(ledgerItem.currency || setting.default_currency, setting.number_format, ledgerItem.net_total)}
                </ResourceTableRowData>
                <ResourceTableRowData onClick={(): void => this.onTableLedgerItemClick(ledgerItem)} textAlign='right'>
                  {NumberFormatter.formatCurrency(ledgerItem.currency || setting.default_currency, setting.number_format, ledgerItem.amount)}
                </ResourceTableRowData>
                <ResourceTableRowActions
                  actions={actions}
                  onActionClick={(key) => this.onTableLedgerItemActionClick(key, ledgerItem)}
                  sticky={true}
                  stickyRight='0px'
                />
              </ResourceTableRow>
            )
          }}
          renderEmpty={<CardEmptyInfo
            icon={filtersActive ? 'search' : 'invoice'}
            description={filtersActive ? t('LedgerItemsTable::No delivery notes found') : t('LedgerItemsTable::No delivery notes have been created yet')}
            descriptionActionText={filtersActive ? t('LedgerItemsTable::Clear filters') : t('LedgerItemsTable::Add delivery note')}
            onDescriptionActionClick={filtersActive ? this.onLedgerItemClearFilters : this.onNewLedgerItemClick}
          />}
          filters={filters}
          activeFilters={activeFilters}
          onFiltersChange={this.onLedgerItemFiltersChange}
          sortOptions={[
            { label: t('LedgerItemsTable::Number ↑'), value: 'number_asc' },
            { label: t('LedgerItemsTable::Number ↓'), value: 'number_desc' },
            { label: t('LedgerItemsTable::Issued on ↑'), value: 'issued_on_asc' },
            { label: t('LedgerItemsTable::Issued on ↓'), value: 'issued_on_desc' },
            { label: t('LedgerItemsTable::Net amount ↑'), value: 'net_total_asc' },
            { label: t('LedgerItemsTable::Net amount ↓'), value: 'net_total_desc' },
            { label: t('LedgerItemsTable::Amount ↑'), value: 'amount_asc' },
            { label: t('LedgerItemsTable::Amount ↓'), value: 'amount_desc' },
            { label: t('LedgerItemsTable::Created at ↑'), value: 'created_at_asc' },
            { label: t('LedgerItemsTable::Created at ↓'), value: 'created_at_desc' },
          ]}
          sortValue={sortValue}
          onSortChange={this.onLedgerItemSortValueChange}
          pagination={{ page: page, perPage: perPage, pageCount: totalPages }}
          onPageChange={this.onPageChange}
          onPerPageChange={this.onPerPageChange}
          searchValue={search}
          onSearchChange={this.onLedgerItemSearchChange}
          onSearchSubmit={this.onLedgerItemSearchSubmit}
          isLoading={isFetching}
          maxHeight='65vh'
          stickyHeader={true}
        />}
      </>
    );
  }

  renderQuotations() {
    const { t } = this.props
    const { currentUser: { workspace: { setting } }, contactId, projectId, primaryActionEnabled } = this.props
    const { didInitialLoad, ledgerItems, page, totalPages, sortValue, isFetching, activeFilters, search, perPage } = this.state;

    const filtersActive = search?.length > 0 || Object.keys(activeFilters).length > 0
    const filters: LedgerItemFilter[] = [
      { name: 'contact_id', label: t('LedgerItemsTable::Client'), type: ResourceListFilterType.SINGLE_RESOURCE, resourceType: 'contact', isValidNewOption: () => false, visible: !Boolean(contactId) },
      { name: 'project_id', label: t('LedgerItemsTable::Project'), type: ResourceListFilterType.SINGLE_RESOURCE, resourceType: 'project', isValidNewOption: () => false, visible: !Boolean(projectId) },
      { name: 'number', label: t('LedgerItemsTable::Number'), type: ResourceListFilterType.STRING },
      { name: 'identifier', label: t('LedgerItemsTable::Identifier'), type: ResourceListFilterType.STRING },
      { name: 'net_total', label: t('LedgerItemsTable::Net amount'), type: ResourceListFilterType.NUMBER },
      { name: 'amount', label: t('LedgerItemsTable::Amount'), type: ResourceListFilterType.NUMBER },
      { name: 'issued_on', label: t('LedgerItemsTable::Issued on'), type: ResourceListFilterType.DATE },
      { name: 'due_on', label: t('LedgerItemsTable::Due on'), type: ResourceListFilterType.DATE },
      { name: 'approved_on', label: t('LedgerItemsTable::Approved on'), type: ResourceListFilterType.DATE },
      { name: 'rejected_on', label: t('LedgerItemsTable::Rejected on'), type: ResourceListFilterType.DATE },
      { name: 'created_at', label: t('LedgerItemsTable::Created date'), type: ResourceListFilterType.DATE },
    ]

    const { headers, columns, selectedColumns, renderRow } = getQuotationTableRenderer({
      setting: setting,
      onRowClick: this.onTableLedgerItemClick,
      onActionClick: this.onTableLedgerItemActionClick,
    })

    return (
      <>
        <Helmet>
          <title>{this.getTitle()}</title>
        </Helmet>
        {!didInitialLoad && <PageLoader />}
        {didInitialLoad && <ResourceTable
          data={ledgerItems}
          headers={headers}
          actionsLeft={primaryActionEnabled ? [
            <ButtonPanel
              icon='plus'
              text={t('LedgerItemsTable::New quote')}
              onClick={this.onNewLedgerItemClick}
            />
          ] : null}
          renderRow={renderRow}
          renderEmpty={<CardEmptyInfo
            icon={filtersActive ? 'search' : 'invoice'}
            description={filtersActive ? t('LedgerItemsTable::No quotes found') : t('LedgerItemsTable::No quotes have been created yet')}
            descriptionActionText={filtersActive ? t('LedgerItemsTable::Clear filters') : t('LedgerItemsTable::Add quote')}
            onDescriptionActionClick={filtersActive ? this.onLedgerItemClearFilters : this.onNewLedgerItemClick}
          />}
          filters={filters}
          activeFilters={activeFilters}
          onFiltersChange={this.onLedgerItemFiltersChange}
          sortOptions={[
            { label: t('LedgerItemsTable::Number ↑'), value: 'number_asc' },
            { label: t('LedgerItemsTable::Number ↓'), value: 'number_desc' },
            { label: t('LedgerItemsTable::Issued on ↑'), value: 'issued_on_asc' },
            { label: t('LedgerItemsTable::Issued on ↓'), value: 'issued_on_desc' },
            { label: t('LedgerItemsTable::Net amount ↑'), value: 'net_total_asc' },
            { label: t('LedgerItemsTable::Net amount ↓'), value: 'net_total_desc' },
            { label: t('LedgerItemsTable::Amount ↑'), value: 'amount_asc' },
            { label: t('LedgerItemsTable::Amount ↓'), value: 'amount_desc' },
            { label: t('LedgerItemsTable::Created at ↑'), value: 'created_at_asc' },
            { label: t('LedgerItemsTable::Created at ↓'), value: 'created_at_desc' },
          ]}
          sortValue={sortValue}
          onSortChange={this.onLedgerItemSortValueChange}
          pagination={{ page: page, perPage: perPage, pageCount: totalPages }}
          onPageChange={this.onPageChange}
          onPerPageChange={this.onPerPageChange}
          isLoading={isFetching}
          searchValue={search}
          onSearchChange={this.onLedgerItemSearchChange}
          onSearchSubmit={this.onLedgerItemSearchSubmit}
          columns={columns}
          selectedColumns={selectedColumns}
          onColumnsChange={this.onQuotationColumnsChange}
          maxHeight='65vh'
          stickyHeader={true}
        />}
      </>
    );
  }

  renderProFormaInvoices() {
    const { t } = this.props
    const { currentUser: { workspace: { setting } }, contactId, projectId, primaryActionEnabled } = this.props
    const { didInitialLoad, ledgerItems, totalPages, page, isFetching, activeFilters, sortValue, search, perPage } = this.state;

    const filtersActive = search?.length > 0 || Object.keys(activeFilters).length > 0
    const filters: LedgerItemFilter[] = [
      { name: 'contact_id', label: t('LedgerItemsTable::Client'), type: ResourceListFilterType.SINGLE_RESOURCE, resourceType: 'contact', isValidNewOption: () => false, visible: !Boolean(contactId) },
      { name: 'project_id', label: t('LedgerItemsTable::Project'), type: ResourceListFilterType.SINGLE_RESOURCE, resourceType: 'project', isValidNewOption: () => false, visible: !Boolean(projectId) },
      { name: 'number', label: t('LedgerItemsTable::Number'), type: ResourceListFilterType.STRING },
      { name: 'po_number', label: t('LedgerItemsTable::PO number'), type: ResourceListFilterType.STRING, visible: setting.po_number_enabled },
      { name: 'identifier', label: t('LedgerItemsTable::Identifier'), type: ResourceListFilterType.STRING },
      { name: 'net_total', label: t('LedgerItemsTable::Net amount'), type: ResourceListFilterType.NUMBER },
      { name: 'amount', label: t('LedgerItemsTable::Amount'), type: ResourceListFilterType.NUMBER },
      { name: 'issued_on', label: t('LedgerItemsTable::Issued on'), type: ResourceListFilterType.DATE },
      { name: 'created_at', label: t('LedgerItemsTable::Created date'), type: ResourceListFilterType.DATE },
    ]

    return (
      <>
        <Helmet>
          <title>{this.getTitle()}</title>
        </Helmet>
        {!didInitialLoad && <PageLoader />}
        {didInitialLoad && <ResourceTable
          data={ledgerItems}
          actionsLeft={primaryActionEnabled ? [
            <ButtonPanel
              icon='plus'
              text={t('LedgerItemsTable::New Proforma invoice')}
              onClick={this.onNewLedgerItemClick}
            />
          ] : null}
          headers={[
            { title: '' },
            { title: t('LedgerItemsTable::Number') },
            { title: t('LedgerItemsTable::Client') },
            { title: t('LedgerItemsTable::Issued on'), align: 'right' },
            { title: t('LedgerItemsTable::Due on'), align: 'right' },
            { title: t('LedgerItemsTable::Net amount'), align: 'right' },
            { title: t('LedgerItemsTable::Amount'), align: 'right' },
            { title: '', stickyRight: '0px' },
          ]}
          renderRow={(ledgerItem: LedgerItem) => {
            let actions: IActionListItem[] = [
              { key: 'send', icon: 'send', content: t('LedgerItemsTable::Send') },
              { key: 'view', icon: 'eye', content: t('LedgerItemsTable::View') },
              { key: 'duplicate', icon: 'duplicate', content: t('LedgerItemsTable::Duplicate') },
              { key: 'edit', icon: 'edit', content: t('LedgerItemsTable::Edit') },
              { key: 'download', icon: 'pdf', content: t('LedgerItemsTable::Download PDF'), visible: Boolean(ledgerItem.pdf_attachment_download_url) },
              { key: 'delete', icon: 'trash-alt-solid', content: t('LedgerItemsTable::Delete'), destructive: true },
            ]

            return (
              <ResourceTableRow key={ledgerItem.id}>
                <ResourceTableRowData onClick={(): void => this.onTableLedgerItemClick(ledgerItem)} maxWidth='30px' maxWidthMobile='50px'>
                  <LedgerItemAvatar width={30} ledgerItem={ledgerItem} rounded={true} onClick={() => this.onTableLedgerItemClick(ledgerItem)} />
                </ResourceTableRowData>
                <ResourceTableRowData onClick={(): void => this.onTableLedgerItemClick(ledgerItem)} maxWidth='150px' ellipse>
                  {ledgerItem.number}
                </ResourceTableRowData>
                <ResourceTableRowData onClick={(): void => this.onTableLedgerItemClick(ledgerItem)} maxWidth='150px' ellipse>
                  {ledgerItem?.contact?.name || '-'}
                </ResourceTableRowData>
                <ResourceTableRowData onClick={(): void => this.onTableLedgerItemClick(ledgerItem)} textAlign='right'>
                  {ledgerItem?.issued_on ? moment(ledgerItem.issued_on).format(setting.date_format) : '-'}
                </ResourceTableRowData>
                <ResourceTableRowData onClick={(): void => this.onTableLedgerItemClick(ledgerItem)} textAlign='right'>
                  {ledgerItem?.due_on ? moment(ledgerItem.due_on).format(setting.date_format) : '-'}
                </ResourceTableRowData>
                <ResourceTableRowData onClick={(): void => this.onTableLedgerItemClick(ledgerItem)} textAlign='right'>
                  {NumberFormatter.formatCurrency(ledgerItem.currency || setting.default_currency, setting.number_format, ledgerItem.net_total)}
                </ResourceTableRowData>
                <ResourceTableRowData onClick={(): void => this.onTableLedgerItemClick(ledgerItem)} textAlign='right'>
                  {NumberFormatter.formatCurrency(ledgerItem.currency || setting.default_currency, setting.number_format, ledgerItem.amount)}
                </ResourceTableRowData>
                <ResourceTableRowActions
                  actions={actions}
                  onActionClick={(key) => this.onTableLedgerItemActionClick(key, ledgerItem)}
                  sticky={true}
                  stickyRight='0px'
                />
              </ResourceTableRow>
            )
          }}
          renderEmpty={<CardEmptyInfo
            icon={filtersActive ? 'search' : 'invoice'}
            description={filtersActive ? t('LedgerItemsTable::No Proforma invoices found') : t('LedgerItemsTable::No Proforma invoices have been created yet')}
            descriptionActionText={filtersActive ? t('LedgerItemsTable::Clear filters') : t('LedgerItemsTable::Add Proforma invoice')}
            onDescriptionActionClick={filtersActive ? this.onLedgerItemClearFilters : this.onNewLedgerItemClick}
          />}
          filters={filters}
          activeFilters={activeFilters}
          onFiltersChange={this.onLedgerItemFiltersChange}
          sortOptions={[
            { label: t('LedgerItemsTable::Number ↑'), value: 'number_asc' },
            { label: t('LedgerItemsTable::Number ↓'), value: 'number_desc' },
            { label: t('LedgerItemsTable::Issued on ↑'), value: 'issued_on_asc' },
            { label: t('LedgerItemsTable::Issued on ↓'), value: 'issued_on_desc' },
            { label: t('LedgerItemsTable::Net amount ↑'), value: 'net_total_asc' },
            { label: t('LedgerItemsTable::Net amount ↓'), value: 'net_total_desc' },
            { label: t('LedgerItemsTable::Amount ↑'), value: 'amount_asc' },
            { label: t('LedgerItemsTable::Amount ↓'), value: 'amount_desc' },
            { label: t('LedgerItemsTable::Created at ↑'), value: 'created_at_asc' },
            { label: t('LedgerItemsTable::Created at ↓'), value: 'created_at_desc' },
          ]}
          sortValue={sortValue}
          onSortChange={this.onLedgerItemSortValueChange}
          pagination={{ page: page, perPage: perPage, pageCount: totalPages }}
          onPageChange={this.onPageChange}
          onPerPageChange={this.onPerPageChange}
          isLoading={isFetching}
          searchValue={search}
          onSearchChange={this.onLedgerItemSearchChange}
          onSearchSubmit={this.onLedgerItemSearchSubmit}
          maxHeight='65vh'
          stickyHeader={true}
        />}
      </>
    )
  }

  renderInvoices() {
    const { t } = this.props
    const { currentUser: { workspace: { setting } }, contactId, projectId, primaryActionEnabled } = this.props
    const { didInitialLoad, ledgerItems, totalPages, page, isFetching, activeFilters, sortValue, search, perPage } = this.state;

    const filtersActive = search?.length > 0 || Object.keys(activeFilters).length > 0
    const filters: LedgerItemFilter[] = [
      { name: 'contact_id', label: t('LedgerItemsTable::Client'), type: ResourceListFilterType.SINGLE_RESOURCE, resourceType: 'contact', isValidNewOption: () => false, visible: !Boolean(contactId) },
      { name: 'project_id', label: t('LedgerItemsTable::Project'), type: ResourceListFilterType.SINGLE_RESOURCE, resourceType: 'project', isValidNewOption: () => false, visible: !Boolean(projectId) },
      {
        name: 'status',
        label: t('LedgerItemsTable::Status'),
        type: ResourceListFilterType.SINGLE_OPTION,
        options: [
          { label: t('LedgerItemsTable::Draft'), value: LedgerItemStatus.DRAFT },
          { label: t('LedgerItemsTable::Outstanding'), value: LedgerItemStatus.OUTSTANDING },
          { label: t('LedgerItemsTable::Overdue'), value: LedgerItemStatus.OVERDUE },
          { label: t('LedgerItemsTable::Paid'), value: LedgerItemStatus.PAID },
        ]
      },
      { name: 'number', label: t('LedgerItemsTable::Number'), type: ResourceListFilterType.STRING },
      { name: 'po_number', label: t('LedgerItemsTable::PO number'), type: ResourceListFilterType.STRING, visible: setting.po_number_enabled },
      { name: 'identifier', label: t('LedgerItemsTable::Identifier'), type: ResourceListFilterType.STRING },
      { name: 'net_total', label: t('LedgerItemsTable::Net amount'), type: ResourceListFilterType.NUMBER },
      { name: 'amount', label: t('LedgerItemsTable::Amount'), type: ResourceListFilterType.NUMBER },
      { name: 'issued_on', label: t('LedgerItemsTable::Issued on'), type: ResourceListFilterType.DATE },
      { name: 'due_on', label: t('LedgerItemsTable::Due on'), type: ResourceListFilterType.DATE },
      { name: 'credited_on', label: t('LedgerItemsTable::Credited on'), type: ResourceListFilterType.DATE },
      { name: 'booked_on', label: t('LedgerItemsTable::Booked on'), type: ResourceListFilterType.DATE },
      { name: 'reminders_enabled', label: t('LedgerItemsTable::Reminders enabled'), type: ResourceListFilterType.SINGLE_OPTION, options: [{ label: t('LedgerItemsTable::Yes'), value: String(true) }, { label: t('LedgerItemsTable::No'), value: String(false) }] },
      { name: 'created_at', label: t('LedgerItemsTable::Created date'), type: ResourceListFilterType.DATE },
    ]

    const { headers, columns, selectedColumns, renderRow } = getInvoiceTableRenderer({
      setting: setting,
      onRowClick: this.onTableLedgerItemClick,
      onActionClick: this.onTableLedgerItemActionClick,
    })

    return (
      <>
        <Helmet>
          <title>{this.getTitle()}</title>
        </Helmet>
        {!didInitialLoad && <PageLoader />}
        {didInitialLoad && <ResourceTable
          data={ledgerItems}
          actionsLeft={primaryActionEnabled ? [
            <ButtonPanel
              icon='plus'
              text={t('LedgerItemsTable::New invoice')}
              onClick={this.onNewLedgerItemClick}
            />
          ] : null}
          headers={headers}
          renderRow={renderRow}
          renderEmpty={<CardEmptyInfo
            icon={filtersActive ? 'search' : 'invoice'}
            description={filtersActive ? t('LedgerItemsTable::No invoices found') : t('LedgerItemsTable::No invoices have been created yet')}
            descriptionActionText={filtersActive ? t('LedgerItemsTable::Clear filters') : t('LedgerItemsTable::Add invoice')}
            onDescriptionActionClick={filtersActive ? this.onLedgerItemClearFilters : this.onNewLedgerItemClick}
          />}
          filters={filters}
          activeFilters={activeFilters}
          onFiltersChange={this.onLedgerItemFiltersChange}
          sortOptions={[
            { label: t('LedgerItemsTable::Number ↑'), value: 'number_asc' },
            { label: t('LedgerItemsTable::Number ↓'), value: 'number_desc' },
            { label: t('LedgerItemsTable::Issued on ↑'), value: 'issued_on_asc' },
            { label: t('LedgerItemsTable::Issued on ↓'), value: 'issued_on_desc' },
            { label: t('LedgerItemsTable::Net amount ↑'), value: 'net_total_asc' },
            { label: t('LedgerItemsTable::Net amount ↓'), value: 'net_total_desc' },
            { label: t('LedgerItemsTable::Amount ↑'), value: 'amount_asc' },
            { label: t('LedgerItemsTable::Amount ↓'), value: 'amount_desc' },
            { label: t('LedgerItemsTable::Created at ↑'), value: 'created_at_asc' },
            { label: t('LedgerItemsTable::Created at ↓'), value: 'created_at_desc' },
          ]}
          sortValue={sortValue}
          onSortChange={this.onLedgerItemSortValueChange}
          pagination={{ page: page, perPage: perPage, pageCount: totalPages }}
          onPageChange={this.onPageChange}
          onPerPageChange={this.onPerPageChange}
          isLoading={isFetching}
          searchValue={search}
          onSearchChange={this.onLedgerItemSearchChange}
          onSearchSubmit={this.onLedgerItemSearchSubmit}
          columns={columns}
          selectedColumns={selectedColumns}
          onColumnsChange={this.onInvoiceColumnsChange}
          maxHeight='65vh'
          stickyHeader={true}
        />}
      </>
    )
  }

  renderCreditNotes() {
    const { currentUser: { workspace: { setting } }, t, contactId, projectId, primaryActionEnabled } = this.props
    const { didInitialLoad, ledgerItems, page, totalPages, isFetching, activeFilters, sortValue, search, perPage } = this.state;

    const filtersActive = search?.length > 0 || Object.keys(activeFilters).length > 0
    const filters: LedgerItemFilter[] = [
      { name: 'contact_id', label: t('LedgerItemsTable::Client'), type: ResourceListFilterType.SINGLE_RESOURCE, resourceType: 'contact', isValidNewOption: () => false, visible: !Boolean(contactId) },
      { name: 'project_id', label: t('LedgerItemsTable::Project'), type: ResourceListFilterType.SINGLE_RESOURCE, resourceType: 'project', isValidNewOption: () => false, visible: !Boolean(projectId) },
      { name: 'number', label: t('LedgerItemsTable::Number'), type: ResourceListFilterType.STRING },
      { name: 'identifier', label: t('LedgerItemsTable::Identifier'), type: ResourceListFilterType.STRING },
      { name: 'net_total', label: t('LedgerItemsTable::Net amount'), type: ResourceListFilterType.NUMBER },
      { name: 'amount', label: t('LedgerItemsTable::Amount'), type: ResourceListFilterType.NUMBER },
      { name: 'issued_on', label: t('LedgerItemsTable::Issued on'), type: ResourceListFilterType.DATE },
      { name: 'booked_on', label: t('LedgerItemsTable::Booked on'), type: ResourceListFilterType.DATE },
      { name: 'created_at', label: t('LedgerItemsTable::Created date'), type: ResourceListFilterType.DATE },
    ]

    const { headers, columns, selectedColumns, renderRow } = getCreditNoteTableRenderer({
      setting: setting,
      onRowClick: this.onTableLedgerItemClick,
      onActionClick: this.onTableLedgerItemActionClick,
    })

    return (
      <>
        <Helmet>
          <title>{this.getTitle()}</title>
        </Helmet>
        {!didInitialLoad && <PageLoader />}

        {didInitialLoad && <ResourceTable
          data={ledgerItems}
          actionsLeft={primaryActionEnabled ? [
            <ButtonPanel
              icon='plus'
              text={t('LedgerItemsTable::New creditnote')}
              onClick={this.onNewLedgerItemClick}
            />
          ] : null}
          headers={headers}
          renderRow={renderRow}
          renderEmpty={<CardEmptyInfo
            icon={filtersActive ? 'search' : 'invoice'}
            description={filtersActive ? t('LedgerItemsTable::No creditnotes found') : t('LedgerItemsTable::No creditnotes have been created yet')}
            descriptionActionText={filtersActive ? t('LedgerItemsTable::Clear filters') : t('LedgerItemsTable::Add creditnote')}
            onDescriptionActionClick={filtersActive ? this.onLedgerItemClearFilters : this.onNewLedgerItemClick}
          />}
          filters={filters}
          activeFilters={activeFilters}
          onFiltersChange={this.onLedgerItemFiltersChange}
          sortOptions={[
            { label: t('LedgerItemsTable::Number ↑'), value: 'number_asc' },
            { label: t('LedgerItemsTable::Number ↓'), value: 'number_desc' },
            { label: t('LedgerItemsTable::Issued on ↑'), value: 'issued_on_asc' },
            { label: t('LedgerItemsTable::Issued on ↓'), value: 'issued_on_desc' },
            { label: t('LedgerItemsTable::Net amount ↑'), value: 'net_total_asc' },
            { label: t('LedgerItemsTable::Net amount ↓'), value: 'net_total_desc' },
            { label: t('LedgerItemsTable::Amount ↑'), value: 'amount_asc' },
            { label: t('LedgerItemsTable::Amount ↓'), value: 'amount_desc' },
            { label: t('LedgerItemsTable::Created at ↑'), value: 'created_at_asc' },
            { label: t('LedgerItemsTable::Created at ↓'), value: 'created_at_desc' },
          ]}
          sortValue={sortValue}
          onSortChange={this.onLedgerItemSortValueChange}
          pagination={{ page: page, perPage: perPage, pageCount: totalPages }}
          onPageChange={this.onPageChange}
          onPerPageChange={this.onPerPageChange}
          isLoading={isFetching}
          searchValue={search}
          onSearchChange={this.onLedgerItemSearchChange}
          onSearchSubmit={this.onLedgerItemSearchSubmit}
          columns={columns}
          selectedColumns={selectedColumns}
          onColumnsChange={this.onCreditNoteColumnsChange}
          maxHeight='65vh'
          stickyHeader={true}
        />}
      </>
    )
  }

  renderRecurringInvoices() {
    const { currentUser: { workspace }, t, contactId, primaryActionEnabled } = this.props
    const { setting } = workspace
    const { didInitialLoad, ledgerItems, totalPages, page, isFetching, activeFilters, sortValue, search, perPage } = this.state;

    const filtersActive = search?.length > 0 || Object.keys(activeFilters).length > 0
    const filters: LedgerItemFilter[] = [
      { name: 'contact_id', label: t('LedgerItemsTable::Client'), type: ResourceListFilterType.SINGLE_RESOURCE, resourceType: 'contact', isValidNewOption: () => false, visible: !Boolean(contactId) },
      { name: 'project_id', label: t('LedgerItemsTable::Project'), type: ResourceListFilterType.SINGLE_RESOURCE, resourceType: 'project', isValidNewOption: () => false, visible: !Boolean(contactId) },
      { name: 'recurring_auto_send', label: t('LedgerItemsTable::Auto send'), type: ResourceListFilterType.SINGLE_OPTION, options: [{ label: t('LedgerItemsTable::Yes'), value: String(true) }, { label: t('LedgerItemsTable::No'), value: String(false) }] },
      { name: 'net_total', label: t('LedgerItemsTable::Net amount'), type: ResourceListFilterType.NUMBER },
      { name: 'amount', label: t('LedgerItemsTable::Amount'), type: ResourceListFilterType.NUMBER },
      { name: 'created_at', label: t('LedgerItemsTable::Created date'), type: ResourceListFilterType.DATE },
    ]

    const { headers, columns, selectedColumns, renderRow } = getRecurringInvoiceTableRenderer({
      setting: setting,
      onRowClick: this.onTableLedgerItemClick,
      onActionClick: this.onTableLedgerItemActionClick,
      onAutoSendToggle: this.onTableLedgerItemRecurringAutoSendToggle,
    })

    return (
      <>
        <Helmet>
          <title>{this.getTitle()}</title>
        </Helmet>
        {!didInitialLoad && <PageLoader />}
        {didInitialLoad && <ResourceTable
          data={ledgerItems}
          actionsLeft={primaryActionEnabled ? [
            <ButtonPanel
              icon='plus'
              text={t('LedgerItemsTable::New recurring invoice')}
              onClick={this.onNewLedgerItemClick}
            />
          ] : null}
          headers={headers}
          renderRow={renderRow}
          renderEmpty={<CardEmptyInfo
            icon={filtersActive ? 'search' : 'invoice'}
            description={filtersActive ? t('LedgerItemsTable::No recurring invoices found') : t('LedgerItemsTable::No recurring invoices have been created yet')}
            descriptionActionText={filtersActive ? t('LedgerItemsTable::Clear filters') : t('LedgerItemsTable::Add recurring invoice')}
            onDescriptionActionClick={filtersActive ? this.onLedgerItemClearFilters : this.onNewLedgerItemClick}
          />}
          filters={filters}
          activeFilters={activeFilters}
          onFiltersChange={this.onLedgerItemFiltersChange}
          sortOptions={[
            { label: t('LedgerItemsTable::Next invoice on ↑'), value: 'recurring_schedules.next_occurrence_on_asc' },
            { label: t('LedgerItemsTable::Next invoice on ↓'), value: 'recurring_schedules.next_occurrence_on_desc' },
            { label: t('LedgerItemsTable::Net amount ↑'), value: 'net_total_asc' },
            { label: t('LedgerItemsTable::Net amount ↓'), value: 'net_total_desc' },
            { label: t('LedgerItemsTable::Amount ↑'), value: 'amount_asc' },
            { label: t('LedgerItemsTable::Amount ↓'), value: 'amount_desc' },
            { label: t('LedgerItemsTable::Created at ↑'), value: 'created_at_asc' },
            { label: t('LedgerItemsTable::Created at ↓'), value: 'created_at_desc' },
          ]}
          sortValue={sortValue}
          onSortChange={this.onLedgerItemSortValueChange}
          pagination={{ page: page, perPage: perPage, pageCount: totalPages }}
          onPageChange={this.onPageChange}
          onPerPageChange={this.onPerPageChange}
          isLoading={isFetching}
          searchValue={search}
          onSearchChange={this.onLedgerItemSearchChange}
          onSearchSubmit={this.onLedgerItemSearchSubmit}
          columns={columns}
          selectedColumns={selectedColumns}
          onColumnsChange={this.onRecurringInvoiceColumnsChange}
          maxHeight='65vh'
          stickyHeader={true}
        />}
      </>
    )
  }

  render() {
    const { type } = this.props

    return <>
      <NavigationDetection onRouteChange={this.onRouteChange} />
      {type === LedgerItemType.ORDER_FORM && this.renderOrderForms()}
      {type === LedgerItemType.DELIVERY_NOTE && this.renderDeliveryNotes()}
      {type === LedgerItemType.QUOTATION && this.renderQuotations()}
      {type === LedgerItemType.PRO_FORMA_INVOICE && this.renderProFormaInvoices()}
      {type === LedgerItemType.INVOICE && this.renderInvoices()}
      {type === LedgerItemType.CREDIT_NOTE && this.renderCreditNotes()}
      {type === LedgerItemType.RECURRING_INVOICE && this.renderRecurringInvoices()}
    </>
  }
}

const mapStateToProps = (state: AppState): IStateToProps => {
  const {
    authentication: {
      currentUser,
    }
  } = state

  return {
    currentUser: currentUser,
  }
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>): IDispatchToProps => {
  return {
    showSendLedgerItemModal: (options) => dispatch(showSendLedgerItemModal(options)),
    showConfirmModal: (options) => dispatch(showConfirmModal(options))
  }
}

// @ts-ignore
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(LedgerItemsTable)) as any) as any